import assets from "../assets"
import { isMember } from "../utils"
import { useRooms } from "../rooms/useRooms"

export const Navbar = () => {

	const rooms = useRooms()

	return <div class="venue-navbar-wrapper">
		<div class="topnavtk2 left-nav" id="myTopnavtk2">
			<a href="https://events.securityforum.org/isfcongress2025" id="LeaveEvent" class="activetk2">Leave Event</a>
			<a href="/atrium" title="Atrium">Atrium</a>
			<div class="dropdowntk2">
				<button class="dropbtntk2">Room Navigation
					<i class="fa fa-caret-down" />
				</button>
				<div class="dropdown-contenttk2">
					{ rooms.map(room => {
						function process(room) {
							const roomAvailable = room.active !== false && room.showNavbar !== false
							if ((room.memberOnly && !isMember) || !room.name || room.available === false || !roomAvailable) return <></>
							return <a href={`/${room?.name?.replaceAll(" ", "-")}`} title={room.name} onClick={room.onClick} style={{textTransform: "capitalize"}}>
								{ room.navName || room.name.replaceAll("-", " ")}
							</a>
						}

						if (Array.isArray(room)) {
							return room.map(process)
						}

						return process(room)
					}) }
				</div>
			</div>
			{
				isMember && <>
					<div class="dropdowntk2">
						<button class="dropbtntk2">Schedules
							<i class="fa fa-caret-down" />
						</button>
						<div class="dropdown-contenttk2">
							<a target="_blank" href="https://events.securityforum.org/isfcongress2025/agendavirtual" title="Full Schedule">Full Schedule</a>
							<a target="_blank" href="https://events.securityforum.org/isfcongress2025/personalagendavirtual" title="Personal Agenda">Personal Agenda</a>
						</div>
					</div>
				</>
			}
			{
				isMember
				? <>
					<div class="dropdowntk2">
						<button class="dropbtntk2">Directories
							<i class="fa fa-caret-down" />
						</button>
						<div class="dropdown-contenttk2">
							<a target="_blank" href="https://events.securityforum.org/isfcongress2025/attendeedirectoryvirtual" title="Attendee Directory">Attendee Directory</a>
							<a target="_blank" href="https://events.securityforum.org/isfcongress2025/speakerdirectoryvirtual" title="Speaker Directory">Speaker Directory</a>
							<a target="_blank" href="https://events.securityforum.org/isfcongress2025/sponsordirectoryvirtual" title="Sponsor Directory">Sponsor Directory</a>
						</div>
					</div>
				</>
				: <a target="_blank" href="https://events.securityforum.org/isfcongress2025/sponsordirectoryvirtual" title="Sponsor Directory">Sponsor Directory</a>
			}
		</div>
		{
			// isMember && window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes" && <>
				<div class="gamification-buttons-wrapper topnavtk2">
					<a class="gamification-button activetk2 aqua" id="how-to-earn" style="cursor: pointer" title="How to Earn Points" onClick={() => document.getElementById("leaderboardTutorial")?.click()}>How to Earn Points</a>
					<a style="cursor: pointer" onclick={() => { document.getElementById("Leaderboard").click() }} title="Leaderboard">Leaderboard</a>
				</div>
			// </>
		}
	</div>
}